// ============================================================================
// CmsPage — full dynamic page for the catch-all route. Lets the Web Editor
// publish BRAND-NEW pages (slugs that don't have a hardcoded React page).
// Wrap with your real <Navbar/> and <Footer/> so new pages match the site.
// Renders the 404 page only when the slug is unknown AND unpublished.
// ============================================================================
import { useLocation } from "react-router-dom";
import { usePublishedLayout, slugFromPath } from "@/lib/cms";
import PublicBlockRenderer from "./PublicBlockRenderer";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";
import NotFound from "@/pages/NotFound";
import { useSEO } from "@/hooks/useSEO";

export default function CmsPage() {
  const { pathname } = useLocation();
  const slug = slugFromPath(pathname);
  const { loading, layout, found } = usePublishedLayout(slug);

  useSEO({ title: `${slug.replace(/-/g, "-")} | ISMAN Engineering`.replace(/\b\w/g, (c) => c.toUpperCase()) });

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-gray-400">
        <i className="ri-loader-4-line animate-spin text-2xl" />
      </div>
    );
  }
  if (!found || !layout) return <NotFound />;

  return (
    <>
      <Navbar />
      <main className="min-h-[60vh]">
        <PublicBlockRenderer blocks={layout} />
      </main>
      <Footer />
    </>
  );
}
